import classNames from 'classnames';
import { useIsQuoted } from 'components/common-form/hooks/useIsQuoted';
import { useSolvedFields } from 'components/common-form/hooks/useSolvedFieldsLabels';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';

export const SolvedFieldsWarnings: FC = () => {
  const { formatMessage, formatNumber } = useIntl();
  const isQuoted = useIsQuoted();

  const solvedFields = useSolvedFields();

  const isRatio = useMemo<boolean>(
    () => solvedFields.length === 2 && Number.isFinite(solvedFields[0].value) && !!solvedFields[1].value,
    [solvedFields],
  );

  const fields = useMemo<string>(
    () => solvedFields.map(field => field.label).join(isRatio ? ' / ' : ', '),
    [solvedFields, isRatio],
  );

  const ratioValue = useMemo<string>(
    () => (isRatio ? formatNumber(solvedFields[0].value / solvedFields[1].value, { maximumFractionDigits: 4 }) : '?'),
    [isRatio, formatNumber, solvedFields],
  );

  const messageKey = useMemo(() => {
    if (isQuoted) {
      return isRatio ? 'form.SolvingMode.warning.withRatio.quoted' : 'form.SolvingMode.warning.quoted';
    } else {
      return isRatio ? 'form.SolvingMode.warning.withRatio.nonQuoted' : 'form.SolvingMode.warning.nonQuoted';
    }
  }, [isQuoted, isRatio]);

  return (
    <small
      className={classNames('form-text', isQuoted ? 'text-success' : 'text-info')}
      data-e2e="solved-fields-warnings"
    >
      {formatMessage(
        { id: messageKey },
        {
          count: solvedFields.length,
          fields,
          ratioValue,
        },
      )}
    </small>
  );
};
SolvedFieldsWarnings.displayName = 'SolvedFieldsWarnings';
